import { createGlobalStyle } from "styled-components";
import themeSizes from "./theme/themeSizes";

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  *,
  :before,
  *:after {
    box-sizing: border-box;
  }

  body {
    font-family: 'Barlow', sans-serif;
    font-size: 13px;
    line-height: 1.33333;
    color: #333;
    #launcher-frame{
      bottom:-12px !important;
    }
  }
  
  a {
    text-decoration: none;
    cursor: pointer;
    color: #333;
  }

  .iTowfl{
    @media ${themeSizes.mobile} {
      flex-direction:column;
    }
    h3{
      width:100%;
    }
  }

  .kFCxPO{
    @media ${themeSizes.mobile} {
      flex-direction:column;
    }
    h3{
      width:100%;
    }
  }

  .cIpPCH{
    @media ${themeSizes.mobile} {
      width:100%;
    }
  }

  .koSGlg{
    @media ${themeSizes.mobile} {
      justify-content:flex-start;
      width:100%
    }
  }

  .sc-fznKkj{
    @media ${themeSizes.tablet} {
      width:100% !important;
    }
  }

  .__react_component_tooltip.view-user-tooltip {
    max-width: min(300px, 85vw) !important;
    text-align: left !important;
    padding: 10px 12px !important;
    border-radius: 8px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3) !important;
    z-index: 99999 !important;
    opacity: 0.98 !important;
    pointer-events: auto !important;
    word-break: break-word !important;
    white-space: normal !important;
  }

  /* Sleek modern scrollbar for view-user tooltip container */
  .view-user-tooltip-scroll,
  .__react_component_tooltip.view-user-tooltip * {
    scrollbar-width: thin !important;
    scrollbar-color: rgba(255, 255, 255, 0.3) transparent !important;

    &::-webkit-scrollbar {
      width: 5px !important;
      height: 5px !important;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.05) !important;
      border-radius: 4px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.28) !important;
      border-radius: 4px !important;
      transition: background 0.2s ease;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.48) !important;
    }

    &::-webkit-scrollbar-button {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
  }
`;

export default GlobalStyle;
